import { c as o } from "../../../index-34b1f277.js";
const { defineMultiStyleConfig: r, definePartsStyle: i } = o([
  "box",
  "content",
  "title",
  "icon",
  "closeButton"
]), n = i({
  box: {
    padding: "spacing-50",
    rounded: "radius-100",
    display: "flex",
    width: "fit-content"
  },
  content: {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    paddingX: "spacing-200",
    paddingY: "spacing-100",
    gap: "spacing-100",
    color: "primary.700"
  },
  icon: { boxSize: "size-200" },
  closeButton: {
    boxSize: "size-200",
    color: "primary.700",
    _dark: {
      color: "primary.700"
    }
  }
}), t = {
  box: {
    bg: "primary.50",
    _dark: {
      bg: "primary.600"
    }
  },
  icon: {
    color: "primary.800"
  },
  closeButton: {
    color: "primary.700",
    _dark: {
      color: "white"
    }
  },
  content: {
    color: "primary.700",
    _dark: {
      color: "white"
    }
  }
}, c = {
  box: {
    bg: "lightBlue.100"
  },
  icon: {
    color: "lightBlue.800"
  }
}, a = {
  box: {
    bg: "success.100"
  },
  icon: {
    color: "success.800"
  }
}, e = {
  box: {
    bg: "secondary.100"
  },
  icon: {
    color: "secondary.800"
  }
}, s = {
  box: {
    bg: "error.100"
  },
  icon: {
    color: "error.800"
  }
}, d = r({
  baseStyle: n,
  variants: {
    default: t,
    info: c,
    success: a,
    warning: e,
    error: s
  },
  defaultProps: {
    variant: "default"
  }
});
export {
  d as Notification,
  t as defaultVariant,
  s as errorVariant,
  c as infoVariant,
  a as successVariant,
  e as warningVariant
};
//# sourceMappingURL=Notification.es.js.map
